
import mock from './mock.js';
/** configure */
import company from './configure/company.js';
import location from './configure/location.js';
import area from './configure/area.js';
import facility from './configure/facility.js';
import equipment from './configure/equipment.js';
import subEquipment from './configure/subEquipment.js';
import department from './configure/department.js';
import device from './configure/device.js';
import employee from './configure/employee.js';
import jobNature from './configure/jobNature.js';
import jobPriority from './configure/jobPriority.js';
import task from './configure/task.js';
import tag from './configure/tag.js';
import jobStatus from './configure/jobStatus.js';
import workCenter from './configure/workCenter.js';
import vendor from './configure/vendor.js';
import workPermit from './configure/workPermit.js';
import equipType from './configure/equipType.js';
import equipCapacity from './configure/equipCapacity.js';
import equipTag from './configure/equipTag.js';
import subEquipTag from './configure/subEquipTag.js';
import deviceTag from './configure/deviceTag.js';
import userRole from './configure/userRole.js';

export default {
    /** configure */
    company,
    location,
    area,
    facility,
    equipment,
    subEquipment,
    department,
    device,
    employee,
    jobNature,
    jobPriority,
    task,
    tag,
    jobStatus,
    workCenter,
    vendor,
    workPermit,
    equipType,
    equipCapacity,
    equipTag,
    subEquipTag,
    deviceTag,
    userRole,

    mock
};
